import axios from "axios";
import { API_URL } from "../../const";

/** *************** START LIST OF AVERAGE MONTHLY PERFORMANCE REPORT  DETAILS ***************** */
export const fetchAverageMonthlyPerformanceReport = (fetchData: JSON) => {
  const data = {
    AverageMonthlyPerformanceReportToken: fetchData,
  };

  const url = `${API_URL}getAverageMonthlyPerformanceReport`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};

/** *************** END LIST OF AVERAGE MONTHLY PERFORMANCE REPORT  DETAILS ***************** */

/** *************** START AVERAGE MONTHLY PERFORMANCE REPORT EXPORT DETAILS ***************** */
export const ComonExportPage = (fetchData: JSON) => {
  const data = {
    CreateRequestReportToken: fetchData,
  };

  const url = `${API_URL}CreateRequestReport`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/** *************** END AVERAGE MONTHLY PERFORMANCE  REPORT EXPORT DETAILS ***************** */
